/**  InvoicingCategory rules */
export const EXEMPTED_VAT_CATEGORY_CODES = ['PUBNS', 'FRN'];
export const ADVERT_CATEGORY_CODE = 'PUB';

export const isCustomCategory = (invoicingCategory: string) => invoicingCategory === 'DIV';
export const isAdvertCategory = (invoicingCategory: string) =>
    ADVERT_CATEGORY_CODE.includes(invoicingCategory ?? '');
export const isVatExempted = (invoicingCategory: string) =>
    EXEMPTED_VAT_CATEGORY_CODES.includes(invoicingCategory ?? '');
